import essApi from "../axios/essApi";

class AttendanceService {
    async createAttendance(param) {
        return Promise.resolve(essApi.post('attendance', param))
    }
    async getAllAttendance() {
        return Promise.resolve(essApi.get('attendance'))
    }
    async getAllAttendanceByUserId(param) {
        return Promise.resolve(essApi.get(`attendance/${param}`))
    }
    async updateAttendanceById(param) {
        // return Promise.resolve(essApi.put(`updateattendance/${param}`))
        return Promise.resolve(essApi.put('updateattendance', param))
    }
    async getAttendanceRequests() {
        return Promise.resolve(essApi.get('attendancerequests'))
    }
    async createAttendanceRequest(param) {
        return Promise.resolve(essApi.post('attendancerequest', param))
    }
    async downloadAttachment(param) {
        return Promise.resolve(essApi.post('donwloadattachment', param, {
            responseType: "arraybuffer",
        }))
    }
    async getPendingAttendance(param) {
        return Promise.resolve(essApi.get(`pendingattendance/${param}`))
    }
    async approveRejectBulkAttendance(param) {
        return Promise.resolve(essApi.put("approve-reject-attendance-request-bulk", param))
    }

    async getAllPendingAttendance() {
        return Promise.resolve(essApi.get('my-attendance-approval'))
    }
    async getAllTeamAttendance() {
        return Promise.resolve(essApi.get('team-attendance'))
    }
    async missingAttendance(param) {
        return Promise.resolve(essApi.post('missing-Attendance', param))
    }
    async getAllUsersBySuperior() {
        return Promise.resolve(essApi.get('userBySuperior'))
    }

    async getAllAttendanceHolidays() {
        return Promise.resolve(essApi.get(`holiday-region`));
    }
    async updateMissingAttendance(param) {
        return Promise.resolve(essApi.put('update-missing-attendance', param));
    }
    async getIsOnLeaveUpdate() {
        return Promise.resolve(essApi.get(`attendance_leave_update`));
    }

    async existingAttendanceCheck(param) {
        return Promise.resolve(essApi.post("attendance-by-date", param));
    }
    async deletemutipleAttendance(param) {
        return Promise.resolve(essApi.post(`delete_multiple_attendance`, param));
    }
    async createMultipleAttendance(param) {
        return Promise.resolve(essApi.post(`multiple-attendance`, param));
    }


    async getUserPaySlip(param) {
        return Promise.resolve(essApi.post(`share-point-document-list`, param));
    }


}

export default AttendanceService;